import React, { useEffect, useRef, useState } from "react";
import themeManager from '../../../utils/themeManager';

export default function MiGallerySection() {
  const [images, setImages] = useState([]);
  const [isDarkMode, setIsDarkMode] = useState(themeManager.isDark());

  const sectionRef = useRef(null);
  const contentRef = useRef(null);

  useEffect(() => {
    const handleThemeChange = (event) => setIsDarkMode(event.detail.theme === 'dark');
    window.addEventListener('themeChanged', handleThemeChange);
    return () => window.removeEventListener('themeChanged', handleThemeChange);
  }, []);
  
  useEffect(() => {
    const loadGallery = async () => {
      try {
        const res = await fetch("/data/gallery.json");
        const data = await res.json();
        const onlyShops = (data.images || []).filter(
          (img) => img.category !== "servis" && img.id !== "ovlasceni-servis"
        );
        setImages(onlyShops);
      } catch (e) { console.error(e); }
    };
    loadGallery();
  }, []);

  const textColor = isDarkMode ? "text-white" : "text-black";
  const bgColor = isDarkMode ? "bg-[#0F1115]" : "bg-[#F3F4F6]";

  return (
    <section ref={sectionRef} className={`relative w-full transition-colors duration-500 overflow-hidden ${bgColor} ${textColor}`}>
      <div className="w-full py-16">

        <div ref={contentRef}>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-[2px]">
            {images.map((p) => {
              const isKragujevacStoreImage = p.id === 8 || p.image.includes('mi-store-kg.webp');
              return (
                <figure key={p.id} data-flip-item className="relative aspect-video md:aspect-square overflow-hidden bg-zinc-900/10">
                  <picture>
                    <source media="(max-width: 768px)" srcSet={p.image.replace('.webp', '-mobile.webp')} />
                    <img
                      src={p.image}
                      alt={p.title}
                      className="h-full w-full object-cover transition-transform duration-500"
                      loading="lazy"
                      style={isKragujevacStoreImage ? { objectPosition: 'center top', transform: 'scale(1.15)' } : undefined}
                    />
                  </picture>
                </figure>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}